import styled from "styled-components";
import { color } from "../../resource";

export const AddProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding: 52px 50px;

  cursor: pointer;

  background: ${color["background1"]};
  border: 1px dashed ${color["primary"]};
  border-radius: 12px;
`;

export const CollapseContainer = styled.div`
  .ant-collapse-content-box {
    background-color: ${color.background4} !important;
    padding: 0px !important;
  }
`;
